import { ApiError, api } from '../api.js'
import { naftaPosAuditService } from './journalState.js'

export const naftaPosAuditClearConfirmation = 'PERMANENTLY_DELETE_NAFTAPOS_AUDIT_EVENTS'
export const auditServiceErrorKey = (cause, fallback) => cause?.code === 'monitoring_service_unconfirmed' ? 'journalServiceUnconfirmed' : fallback
const unconfirmed = () => new ApiError('Audit service could not be confirmed', 403, 'monitoring_service_unconfirmed')

export async function naftaPosAuditApi(path, options = {}, transport = api) {
  const method = (options.method ?? 'GET').toUpperCase()
  if (method === 'PUT' || method === 'DELETE') {
    let body
    try { body = JSON.parse(options.body) } catch { throw unconfirmed() }
    if (body?.service !== naftaPosAuditService || method === 'DELETE' && body.confirmation !== naftaPosAuditClearConfirmation) throw unconfirmed()
  }
  const [pathname, query = ''] = path.split('?'), params = new URLSearchParams(query)
  params.set('service', naftaPosAuditService)
  const payload = await transport(`${pathname}?${params}`, options)
  if (payload?.service !== naftaPosAuditService) throw unconfirmed()
  return payload
}
